(() => {
  'use strict';
  const configNode = document.getElementById('outletlet-fr-de-draft-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const locale = String(config.locale || '');
  if (config.enabled !== true || config.deployment !== 'release' || config.pageType !== 'page' ||
      config.pageHandle !== 'digital-rearview-mirror' || !['fr', 'de'].includes(locale) ||
      document.documentElement.lang.toLowerCase().split('-')[0] !== locale ||
      !/\/pages\/digital-rearview-mirror\/?$/.test(window.location.pathname)) return;

  const namespace = 'OutletletFrDeDraft';
  const defaultTextScopes = ['.__pf', '.shopify-section-group-header-group', 'footer-group', 'a.skip-link[href="#MainContent"]'];
  if (window[namespace]?.destroy) window[namespace].destroy();
  const stats = { locale, textChanges: 0, attributeChanges: 0, imageChanges: 0, interfaceChanges: 0, conflicts: [], unmatched: [], interfaceUnmatched: [] };
  const undo = [];
  const matched = new Set();
  const textMap = new Map();
  const richMap = new Map();
  const protectedSelector = 'script,style,noscript,template,textarea,input,select,option,iframe,[contenteditable],#looxReviews,#outletlet-japan-locale,#ol-jp-v2';
  let stopped = false;
  let scheduled = false;
  let observer;
  let resizeObserver;
  let frameId;

  const canonicalHTML = value => {
    const template = document.createElement('template');
    template.innerHTML = value;
    return template.innerHTML;
  };
  const decodeTextEntities = value => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  };
  const textKey = value => typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : '';
  const withOuterWhitespace = (before, target) => {
    const leading = before.match(/^\s*/)[0];
    const trailing = before.match(/\s*$/)[0];
    return leading + target.trim() + trailing;
  };
  for (const entry of config.entries || []) {
    if (typeof entry.source !== 'string' || typeof entry.target !== 'string' || !entry.source || entry.disabled === true) continue;
    const rich = /<\/?[a-z][\s\S]*>/i.test(entry.source);
    if (rich && /<(?:script|style|iframe|img|input|button|select|form)\b/i.test(entry.source + entry.target)) {
      stats.conflicts.push({ id: entry.id, reason: 'interactive_or_unsafe_rich_content_skipped' });
      continue;
    }
    const key = rich ? canonicalHTML(entry.source) : textKey(decodeTextEntities(entry.source));
    const target = rich ? canonicalHTML(entry.target) : decodeTextEntities(entry.target);
    if (!key) continue;
    const map = rich ? richMap : textMap;
    const prior = map.get(key);
    if (prior && prior.target !== target) {
      prior.conflict = true;
      stats.conflicts.push({ id: entry.id, group: entry.group, reason: 'same_source_has_different_target_needs_explicit_selector' });
    } else if (!prior) map.set(key, { ...entry, target });
  }

  function setAttr(node, name, value) {
    if (typeof value !== 'string' || node.getAttribute(name) === value) return;
    const before = node.getAttribute(name);
    node.setAttribute(name, value);
    undo.push(() => {
      if (node.getAttribute(name) !== value) return;
      if (before === null) node.removeAttribute(name); else node.setAttribute(name, before);
    });
    stats.attributeChanges += 1;
  }
  function setText(node, value, entry) {
    const before = node.nodeValue;
    if (before === value) return;
    node.nodeValue = value;
    undo.push(() => { if (node.nodeValue === value) node.nodeValue = before; });
    matched.add(entry.id || entry.source);
    stats.textChanges += 1;
  }
  function excluded(node) { return Boolean(node.parentElement?.closest(protectedSelector)); }
  function translateRoot(root) {
    for (const element of [root, ...root.querySelectorAll('*')]) {
      if (element.closest(protectedSelector)) continue;
      const entry = richMap.get(element.innerHTML);
      if (entry && !entry.conflict && !element.querySelector('a,button,input,select,textarea,iframe,[data-pf-type="Button2"]')) {
        const before = element.innerHTML;
        element.innerHTML = entry.target;
        undo.push(() => { if (element.innerHTML === entry.target) element.innerHTML = before; });
        matched.add(entry.id || entry.source);
        stats.textChanges += 1;
      }
      for (const name of ['alt', 'title', 'aria-label', 'placeholder']) {
        const attributeEntry = textMap.get(textKey(element.getAttribute(name)));
        if (attributeEntry && !attributeEntry.conflict) {
          setAttr(element, name, attributeEntry.target.trim());
          matched.add(attributeEntry.id || attributeEntry.source);
        }
      }
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      if (excluded(node)) continue;
      const entry = textMap.get(textKey(node.nodeValue));
      if (entry && !entry.conflict) setText(node, withOuterWhitespace(node.nodeValue, entry.target), entry);
    }
  }

  function translateThemeInterface() {
    const unmatched = [];
    for (const entry of config.themeInterface || []) {
      if (!entry || typeof entry.selector !== 'string' || !entry.selector.startsWith('footer-group ') ||
          typeof entry.controlId !== 'string' || !entry.controlId || typeof entry.source !== 'string' ||
          typeof entry.target !== 'string' || !['placeholder', 'aria-label', 'text'].includes(entry.attribute)) continue;
      const control = document.getElementById(entry.controlId);
      if (!control || !control.matches('input[type="email"][name="contact[email]"]') || !control.closest('footer-group')) continue;
      const form = control.closest('form');
      if (!form) continue;
      let elements;
      try { elements = document.querySelectorAll(entry.selector); } catch (_) { continue; }
      if (elements.length !== 1) { unmatched.push(entry.id); continue; }
      const element = elements[0];
      if (!element.closest('footer-group')) continue;
      const isText = entry.attribute === 'text';
      const allowed = entry.attribute === 'placeholder' ? element === control : isText
        ? element.tagName === 'LABEL' && element.getAttribute('for') === entry.controlId && element.childElementCount === 0 && element.closest('form') === form
        : element.matches('button[type="submit"]') && element.closest('form') === form;
      if (!allowed) continue;
      const current = isText ? element.textContent : element.getAttribute(entry.attribute);
      const expected = decodeTextEntities(entry.source);
      const target = decodeTextEntities(entry.target);
      if (current === target) continue;
      if (current !== expected) { unmatched.push(entry.id); continue; }
      if (isText) {
        const before = element.textContent;
        element.textContent = target;
        undo.push(() => { if (element.textContent === target) element.textContent = before; });
      } else setAttr(element, entry.attribute, target);
      stats.interfaceChanges += 1;
    }
    stats.interfaceUnmatched = unmatched;
  }

  function identity(value) {
    if (!value) return '';
    try {
      const url = new URL(value, document.baseURI);
      if (!['http:', 'https:'].includes(url.protocol)) return '';
      return url.host + url.pathname;
    } catch (_) { return ''; }
  }
  const imageMap = new Map();
  const images = (config.images || []).filter(item => item.targetUrl && /^https:\/\//.test(item.targetUrl));
  for (const item of images) for (const source of [...(item.sources || []), item.targetUrl]) {
    const key = identity(source);
    if (key) imageMap.set(key, item);
  }
  function imageEntry(element) {
    for (const name of ['src', 'data-src', 'data-lazy-src', 'data-image']) {
      const found = imageMap.get(identity(element.getAttribute(name)));
      if (found) return found;
    }
    for (const name of ['srcset', 'data-srcset', 'data-lazy-srcset']) {
      for (const part of (element.getAttribute(name) || '').split(',')) {
        const found = imageMap.get(identity(part.trim().split(/\s+/)[0]));
        if (found) return found;
      }
    }
    return null;
  }
  function replaceImages(root) {
    for (const element of root.querySelectorAll('img,[data-image],picture source')) {
      if (element.closest(protectedSelector)) continue;
      const entry = imageEntry(element);
      if (!entry || (entry.selector && !element.matches(entry.selector))) continue;
      if (element.hasAttribute('data-image')) setAttr(element, 'data-image', entry.targetUrl);
      if (element.tagName === 'IMG' || element.tagName === 'SOURCE') {
        if (element.tagName === 'IMG') setAttr(element, 'src', entry.targetUrl);
        for (const name of ['srcset', 'data-srcset', 'data-lazy-srcset']) if (element.hasAttribute(name)) setAttr(element, name, entry.targetUrl);
        for (const name of ['data-src', 'data-lazy-src']) if (element.hasAttribute(name)) setAttr(element, name, entry.targetUrl);
        if (element.tagName === 'IMG') {
          if (entry.alt) setAttr(element, 'alt', entry.alt);
          if (entry.width && entry.height) { setAttr(element, 'width', String(entry.width)); setAttr(element, 'height', String(entry.height)); }
          const imageLink = element.closest('a');
          const linkedSource = imageLink && identity(imageLink.getAttribute('href'));
          if (linkedSource && [...(entry.sources || []), entry.targetUrl].some(source => identity(source) === linkedSource)) {
            setAttr(imageLink, 'href', entry.targetUrl);
          }
          const picture = element.closest('picture');
          if (picture) for (const source of picture.querySelectorAll('source')) {
            setAttr(source, 'srcset', entry.targetUrl);
            for (const name of ['data-srcset', 'data-lazy-srcset']) if (source.hasAttribute(name)) setAttr(source, name, entry.targetUrl);
          }
        }
        if (!matched.has(entry.id)) stats.imageChanges += 1;
        matched.add(entry.id);
      }
    }
  }

  const heroLinks = new Map();
  function positionHeroLinks() {
    for (const [image, link] of heroLinks) {
      const parent = link.parentElement;
      if (!parent || !image.isConnected) continue;
      const imageRect = image.getBoundingClientRect();
      const parentRect = parent.getBoundingClientRect();
      link.style.left = `${imageRect.left - parentRect.left + parent.scrollLeft}px`;
      link.style.top = `${imageRect.top - parentRect.top + parent.scrollTop}px`;
      link.style.width = `${imageRect.width}px`;
      link.style.height = `${imageRect.height}px`;
    }
  }
  function installHeroLinks(root) {
    if (!config.heroLabel || !document.getElementById('pf-shopping-area')) return;
    for (const image of root.querySelectorAll('img[data-action="section"][data-to-section="pf-05c9"]')) {
      const entry = imageEntry(image);
      if (!entry || !String(entry.id).startsWith('HERO-') || heroLinks.has(image)) continue;
      if (image.closest('a')) { setAttr(image.closest('a'), 'aria-label', config.heroLabel); continue; }
      const parent = image.closest('picture')?.parentElement || image.parentElement;
      if (!parent) continue;
      if (getComputedStyle(parent).position === 'static') {
        const oldPosition = parent.style.position;
        parent.style.position = 'relative';
        undo.push(() => { if (parent.style.position === 'relative') parent.style.position = oldPosition; });
      }
      const link = document.createElement('a');
      link.className = 'outletlet-fr-de-hero-link';
      link.href = '#pf-shopping-area';
      link.setAttribute('aria-label', config.heroLabel);
      link.style.cssText = 'position:absolute;display:block;z-index:2;background:transparent;';
      link.addEventListener('click', event => {
        const purchase = document.getElementById('pf-shopping-area');
        if (!purchase) return;
        event.preventDefault();
        event.stopPropagation();
        window.scrollTo({ top: Math.max(0, purchase.getBoundingClientRect().top + window.scrollY - 50), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
      parent.appendChild(link);
      heroLinks.set(image, link);
      resizeObserver?.observe(image);
      undo.push(() => { link.remove(); heroLinks.delete(image); });
    }
    positionHeroLinks();
  }
  function apply() {
    scheduled = false;
    if (stopped) return;
    const selectors = config.textScopes || defaultTextScopes;
    for (const selector of selectors) for (const root of document.querySelectorAll(selector)) translateRoot(root);
    translateThemeInterface();
    for (const root of document.querySelectorAll('.__pf')) { replaceImages(root); installHeroLinks(root); }
    stats.unmatched = (config.entries || []).filter(entry => !matched.has(entry.id || entry.source)).map(entry => ({ id: entry.id, group: entry.group }));
    observer?.takeRecords();
  }
  function schedule() {
    if (!stopped && !scheduled) { scheduled = true; frameId = requestAnimationFrame(apply); }
  }
  function start() {
    if (stopped || observer) return;
    resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(positionHeroLinks) : null;
    apply();
    observer = new MutationObserver(records => {
      if (records.some(record => !record.target.parentElement?.closest(protectedSelector))) schedule();
    });
    for (const selector of new Set([...(config.textScopes || defaultTextScopes), '.__pf'])) {
      for (const root of document.querySelectorAll(selector)) observer.observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['src','srcset','data-src','data-srcset','data-lazy-src','data-lazy-srcset','data-image','alt','title','aria-label','placeholder'] });
    }
    window.addEventListener('resize', positionHeroLinks);
  }
  function destroy() {
    stopped = true;
    observer?.disconnect();
    resizeObserver?.disconnect();
    cancelAnimationFrame(frameId);
    window.removeEventListener('resize', positionHeroLinks);
    document.removeEventListener('DOMContentLoaded', start);
    for (const restore of undo.reverse()) restore();
    undo.length = 0;
  }
  window[namespace] = { version: '1.0.0-release', refresh: schedule, destroy, stats };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();

